import {
    APP_TYPE_BOTH,
    APP_TYPE_FOODO,
    APP_TYPE_GOPOSH,
    AR_CATEGORY_GROUP_POSITION
} from "../../../../constants";

const APP_TYPE_LIST = [
    { label: "FOODO (AR MENU LISTING ONLY)", value: APP_TYPE_FOODO },
    { label: "GOPOSH (TABLE ORDER ONLY)", value: APP_TYPE_GOPOSH },
    { label: "BOTH (AR MENU + TABLE ORDER)", value: APP_TYPE_BOTH },
];

const PAYMENT_GATEWAYS = [
  { label: "Stripe", value: "stripe" },
  { label: "Dojo", value: "dojo" },
  { label: "Ryft", value: "ryft" },
];

const TABLE_ORDER_GATEWAYS = [
  { label: "Stripe", value: "stripe" },
  { label: "Dojo", value: "dojo" },
  { label: "Direct", value: "direct" },
  { label: "Ryft", value: "ryft" },
];

const CategoriesFields = {
  name: "name",
  categories: "categories",
  imageWidth: "imageWidth",
  imageHeight: "imageHeight",
  img: "img",
};

const SocialMediaFields = {
  name: "name",
  url: "url",
  action: "action",
  icon: "icon",
  iconWidth: "iconWidth",
  iconHeight: "iconHeight",
};

const SectionNames = {
  ImagesTab: "ImagesTab",
  ARPageTab: "ARPageTab",
  MenuListingTab: "MenuListingTab",
  MenuDetailsPopupTab: "MenuDetailsPopupTab",
  CartTab: "CartTab",
  CheckoutTab: "CheckoutTab",
  OrderSuccessTab: "OrderSuccessTab",
  OrderHistoryTab: "OrderHistoryTab",
  OrderDetailsTab: "OrderDetailsTab",
  AddAddressTab: "AddAddressTab",
  AddressListTab: "AddressListTab",
  socialMediaTab: "socialMediaTab",
  categoryGroupsTab: "categoryGroupsTab",
  PaymentSettingsTab: "PaymentSettingsTab",
  MultiLanguageTab: "MultiLanguageTab",
  WhiteListDomainTab: "WhiteListDomainTab",
  TableOrderingMenuLayoutTab: "TableOrderingMenuLayoutTab",
};

const FieldTypes = {
    color: 'color',
    switch: 'switch',
    fontsize: 'fontsize',
    select: 'select',
    multiselect: 'multiselect',
    stringInput: 'sInput',
    file: 'file',
    image: 'image'
}

// Note: the key of the meta data object and the name property should be same
const MetaData = {
    [SectionNames.ImagesTab]: {
        images: {
            printLogo: {
                label: "PRINT LOGO",
                name: "printLogo",
                info: "Upload the logo that needs to be printed in receipts",
                type: FieldTypes.image,
            },
            headerBg: {
                label: "Header Bg",
                name: "headerBg",
                info: "",
                type: FieldTypes.image,
            },
            menuHeaderBg: {
                label: "Main Header Bg",
                name: "menuHeaderBg",
                info: "Header background image that needs to be shown on ar 3d page top section",
                type: FieldTypes.image,
            },
            arModelBg: {
                label: "AR Model Bg",
                name: "arModelBg",
                info: "Background image shown at the 3d model page",
                type: FieldTypes.image,
            },
            bottomMenuIcon: {
                label: "Bottom Menu Icon",
                name: "bottomMenuIcon",
                info: "Icon image shown for the menu button in 3d page bottom centre section",
                type: FieldTypes.image,
            },
            menuSectionBgVal: {
                label: "Menu Section Img",
                name: "menuSectionBgVal",
                info: "Background image for bottom menu section in ar 3d page",
                type: FieldTypes.image,
            },
            prevIcon: {
                label: "Prev Icon",
                name: "prevIcon",
                info: "Icon image shown for the previous button in 3d page bottom menu section",
                type: FieldTypes.image,
            },
            nextIcon: {
                label: "Next Icon",
                name: "nextIconVal",
                info: "Icon image shown for the next button in 3d page bottom menu section",
                type: FieldTypes.image,
            },
            arMenuLogo: {
                label: "AR Menu Logo",
                name: "arMenuLogo",
                info: "Upload the AR logo for the restaurant",
                type: FieldTypes.image,
            },
            shareIconImage: {
                label: "Share Icon Image",
                name: "shareIconImage",
                info: "Upload the share icon image for the restaurant",
                type: FieldTypes.image,
            },
            

        },
        switches: {
            onlineOrder: {
                label: "Online Order",
                name: "onlineOrder",
                defaultValue: false,
                info: "Toggle option for user to place order online",
                type: FieldTypes.switch,
            },
            tableOrder: {
                label: "Table Order",
                name: "tableOrder",
                defaultValue: false,
                info: "Toggle option for user to place table order",
                type: FieldTypes.switch,
            },
            // batchOrderEnabled:true
            batchOrderEnabled: {
                label: "Order Grouping",
                name: "batchOrderEnabled",
                defaultValue: false,
                info: "Toggle option for user to place batch order",
                type: FieldTypes.switch,
            },
            tablePayment: {
                label: "Table Payment",
                name: "tablePayment",
                defaultValue: false,
                info: "Toggle option for user to make payment for table and online order",
                type: FieldTypes.switch,
            },
            wifiAvailable: {
                label: "Wifi Available",
                name: "wifiAvailable",
                defaultValue: false,
                info: "Toggle option to show wifi icon in 3d menu page for user",
                type: FieldTypes.switch,
            },
        },
        select: {
            appType: {
                label: "App Type",
                name: 'appType',
                info: "",
                type: FieldTypes.select,
                optionsList: APP_TYPE_LIST
            },
        }
    },
    [SectionNames.ARPageTab]: {
        normalRender: {
            menuItemFontColor: {
                label: "Menu Item Font Color",
                name: "menuItemFontColor",
                defaultValue: null,
                type: FieldTypes.color,
                info: "Font color for menu name & price in the top section in the ar page",
            },
            menuItemFontBg: {
                label: "Menu Item Font Bg",
                name: "menuItemFontBg",
                defaultValue: null,
                type: FieldTypes.color,
                info: "Background color for menu name & price section in the ar page",
            },
            menuItemFontName: {
                label: "Menu Item Font Name",
                name: "menuItemFontName",
                defaultValue: null,
                type: FieldTypes.stringInput,
            },
            menuItemFontFile: {
                label: "Menu Item Font File",
                name: "menuItemFontFile",
                defaultValue: null,
                type: FieldTypes.file,
            },
            modalBgColor: {
                label: "Modal Bg Color",
                name: "modalBgColor",
                defaultValue: null,
                type: FieldTypes.color,
                info: "Background color for user form modal in the ar page",
            },
            modalFontColor: {
                label: "Modal Font Color",
                name: "modalFontColor",
                defaultValue: null,
                type: FieldTypes.color,
                info: "Font color for texts in user form modal in the ar page",
            },
            userFormDataBg: {
                label: "User Form Data Bg",
                name: "userFormDataBg",
                defaultValue: null,
                type: FieldTypes.color,
                info: "Background color for input section in user modal form in the ar page",
            },
            userFormDataLabelColor: {
                label: "User Form Data Label Color",
                name: "userFormDataLabelColor",
                defaultValue: null,
                type: FieldTypes.color,
                info: "Font color for input label in user form modal in the ar page",
            },
            userFormDataFontColor: {
                label: "User Form Data Font Color",
                name: "userFormDataFontColor",
                defaultValue: null,
                type: FieldTypes.color,
                info: "Font color for inputs in user form modal in the ar page",
            },
            buttonBg: {
                label: "Button Bg",
                name: "buttonBg",
                defaultValue: null,
                type: FieldTypes.color,
                info: "Background color for button in user form modal in the ar page",
            },
            buttonTextBg: {
                label: "Button Text Bg",
                name: "buttonTextBg",
                defaultValue: null,
                type: FieldTypes.color,
                info: "Font color for button text in user form modal in the ar page",
            },
            arCategoryGrouping: {
                label: "Category Grouping",
                name: "arCategoryGrouping",
                defaultValue: false,
                type: FieldTypes.switch,
                info: "Toggle option to show category grouping in ar page",
            },
        },
        conditionalRender: {
            arCategoryGroupingPosition: {
                label: "Category Grouping position",
                name: "arCategoryGroupingPosition",
                defaultValue: AR_CATEGORY_GROUP_POSITION[0].value,
                type: FieldTypes.select,
                info: "Font color for button text in user form modal in the ar page",
                optionsList: AR_CATEGORY_GROUP_POSITION
            }
        }
    },
    [SectionNames.MenuListingTab]: {
        menuListingBgColor: {
            label: "Bg Color",
            name: 'menuListingBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: "Background color for menu list page",
        },
        menuListingFontColor: {
            label: "Font Color",
            name: 'menuListingFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: "Font color for category name, menu name, description, price in menu list page",
        },
        menuListingCategoryFontColor: {
            label: "Category Font Color",
            name: 'menuListingCategoryFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: "Font color for categories shown in the top section of the menu list page",
        },
        menuListingCategoryBgColor: {
            label: "Category Bg Color",
            name: 'menuListingCategoryBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: "Background color for categories shown in the top section of the menu list page",
        },
        menuListingSelectedCategoryFontColor: {
            label: "Selected Category Font Color",
            name: 'menuListingSelectedCategoryFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: "Font color for selected category shown in the top section of the menu list page",
        },
        menuListingSelectedCategoryBgColor: {
            label: "Selected Category Bg Color",
            name: 'menuListingSelectedCategoryBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: "Background color for selected category shown in the top section of the menu list page",
        },
        menuListingDishNotesBgColor: {
            label: "Dish Notes Bg Color",
            name: 'menuListingDishNotesBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: "Background color for dish notes in menu list page",
        },
        menuListingDishNotesFontColor: {
            label: "Dish Notes Font Color",
            name: 'menuListingDishNotesFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: "Font color for dish notes in menu list page",
        },
        menuListingAddBtnBgColor: {
            label: "Add Btn Bg Color",
            name: 'menuListingAddBtnBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: "Background color for menu add button shown in the bottom of menu image in the menu list page",
        },
        menuListingAddBtnFontColor: {
            label: "Add Btn Font Color",
            name: 'menuListingAddBtnFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: "Font color for menu add button shown in the bottom of menu image in the menu list page",
        },
        menuListingItemImgBgColor: {
            label: "Item Img Bg Color",
            name: 'menuListingItemImgBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: "Background color for menu image in the menu list page",
        },
        menuListingArBtnBgColor: {
            label: "Ar Btn Bg Color",
            name: 'menuListingArBtnBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: "Background color for AR icon shown in the top right of menu image in the menu list page",
        },
        menuListingArBtnIconColor: {
            label: "Ar Btn Icon Color",
            name: 'menuListingArBtnIconColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: "Color for AR icon shown in the top right of menu image in the menu list page",
        },
        menuListingMenuTypeFilterBgColor: {
            label: "Menu Type Filter Bg Color",
            name: 'menuListingMenuTypeFilterBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: "Background color for menu type filter shown in the top left of the menu list page",
        },
        menuListingMenuTypeFilterFontColor: {
            label: "Menu Type Filter Font Color",
            name: 'menuListingMenuTypeFilterFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: "Font color for menu type filter shown in the top left of the menu list page",
        },
        menuListingBackBtnColor: {
            label: "Back Btn Color",
            name: 'menuListingBackBtnColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: "Color for back icon shown in the top left of the menu list page",
        },
        menuListingSearchInputBgColor: {
            label: "Search Input Bg Color",
            name: 'menuListingSearchInputBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: "Background color for search input shown in the top of the menu list page",
        },
        menuListingSearchInputFontColor: {
            label: "Search Input Font Color",
            name: 'menuListingSearchInputFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: "Font color for search input shown in the top of the menu list page",
        },
        menuListingSearchInputIconColor: {
            label: "Search Input Icon Color",
            name: 'menuListingSearchInputIconColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: "Color for search icon shown in the top of the menu list page",
        },
        menuListingOrderHistoryIconColor: {
            label: "Order History Icon Color",
            name: 'menuListingOrderHistoryIconColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: "Color for order history icon shown in the right top of the menu list page",
        },
        menuListingTopHeaderShadow: {
            label: "Top Header Shadow",
            name: 'menuListingTopHeaderShadow',
            value: true,
            defaultValue: true,
            type: FieldTypes.switch,
            info: "Toggle option to show top header shadow in menu listing page",
        },
    },
    [SectionNames.MenuDetailsPopupTab]: {
        menuPopupItemFontColor: {
            label: 'Item Font Color',
            name: 'menuPopupItemFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for menu name & price in the menu detail popup'
        },
        menuPopupItemPriceFontSize: {
            label: 'Item Price Font Size (Default 18px)',
            name: 'menuPopupItemPriceFontSize',
            defaultValue: null,
            type: FieldTypes.fontsize
        },
        menuPopupItemBgColor: {
            label: 'Item Bg Color',
            name: 'menuPopupItemBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for top card section in the menu detail popup'
        },
        menuPopupModifierBgColor: {
            label: 'Modifier Bg Color',
            name: 'menuPopupModifierBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for modifier list section in the menu detail popup'
        },
        menuPopupModifierFontColor: {
            label: 'Modifier Font Color',
            name: 'menuPopupModifierFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for modifier list section in the menu detail popup'
        },
        menuPopupModifierPriceFontSize: {
            label: 'Modifier Price Font Size (Default 14px)',
            name: 'menuPopupModifierPriceFontSize',
            defaultValue: null,
            type: FieldTypes.fontsize
        },
        menuPopupAddToCartBtnBgColor: {
            label: 'Add To Cart Btn Bg Color',
            name: 'menuPopupAddToCartBtnBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for add btn in the bottom section of the menu detail popup & Background color for view cart btn in the bottom section of the menu list page'
        },
        menuPopupAddToCartBtnFontColor: {
            label: 'Add To Cart Btn Font Color',
            name: 'menuPopupAddToCartBtnFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for add btn in the bottom section of the menu detail popup & Font color for view cart btn in the bottom section of the menu list page'
        },
        menuPopupBgColor: {
            label: 'Bg Color',
            name: 'menuPopupBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for menu detail popup'
        },
        menuPopupItemDescFontColor: {
            label: 'Description Font Color',
            name: 'menuPopupItemDescFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for menu description in the menu detail popup'
        },
        menuPopupAddNoteBgColor: {
            label: 'Add Note Bg Color',
            name: 'menuPopupAddNoteBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for add note section in the menu detail popup'
        },
        menuPopupAddNoteFontColor: {
            label: 'Add Note Font Color',
            name: 'menuPopupAddNoteFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for add note section in the menu detail popup'
        },
        menuPopupQtyBtnBgColor: {
            label: 'Qty Btn Bg Color',
            name: 'menuPopupQtyBtnBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for quantity add btn in the bottom section of the menu detail popup'
        },
        menuPopupQtyBtnFontColor: {
            label: 'Qty Btn Font Color',
            name: 'menuPopupQtyBtnFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for quantity add btn in the bottom section of the menu detail popup'
        }
    },
    [SectionNames.CartTab]: {
        cartBgColor: {
            label: 'Bg Color',
            name: 'cartBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for cart page'
        },
        cartCardHeaderFontSize: {
            label: 'Card Header Font Size (Default 15px)',
            name: 'cartCardHeaderFontSize',
            defaultValue: null,
            type: FieldTypes.fontsize
        },
        cartCardItemNameFontSize: {
            label: 'Card Item Name Font Size (Default 14px)',
            name: 'cartCardItemNameFontSize',
            defaultValue: null,
            type: FieldTypes.fontsize
        },
        cartCardItemPriceFontSize: {
            label: 'Card Item Price Font Size (Default 14px)',
            name: 'cartCardItemPriceFontSize',
            defaultValue: null,
            type: FieldTypes.fontsize
        },
        cartCardBgColor: {
            label: 'Card Bg Color',
            name: 'cartCardBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for card sections in the cart page'
        },
        cartCardHeaderFontColor: {
            label: 'Card Header Font Color',
            name: 'cartCardHeaderFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for text in the header section of the card in the cart page'
        },
        cartCardItemNameFontColor: {
            label: 'Card Item Name Font Color',
            name: 'cartCardItemNameFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for menu name in the card in the cart page'
        },
        cartCardItemPriceFontColor: {
            label: ' Card Item Price Font Color',
            name: 'cartCardItemPriceFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for menu price in the card in the cart page'
        },
        cartCardModifierFontColor: {
            label: 'Card Modifier Font Color',
            name: 'cartCardModifierFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for modifiers in the card in the cart page'
        },
        cartCardTotalPriceFontColor: {
            label: 'Card Total Price Font Color',
            name: 'cartCardTotalPriceFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for total price in the bottom right of card in the cart page'
        },
        cartCardTotalQtyFontColor: {
            label: 'Card Total Qty Font Color',
            name: 'cartCardTotalQtyFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for total quantity in the bottom left of card in the cart page'
        },
        cartCardQtyBgColor: {
            label: 'Card Qty Bg Color',
            name: 'cartCardQtyBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for quantity add btn in the card in the cart page'
        },
        cartCardQtyFontColor: {
            label: 'Card Qty Font Color',
            name: 'cartCardQtyFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for quantity add btn in the card in the cart page'
        },
        cartCardDeleteIconColor: {
            label: 'Card Delete Icon Color',
            name: 'cartCardDeleteIconColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Color for delete icon in the card in the cart page'
        },
        cartCardStatusBgColor: {
            label: 'Card Status Bg Color',
            name: 'cartCardStatusBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for status in the top right section of the card in the cart page'
        },
        cartCardStatusFontColor: {
            label: 'Card Status Font Color',
            name: 'cartCardStatusFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for status in the top right section of the card in the cart page'
        },
        cartViewOrderBtnBgColor: {
            label: 'View Order Btn Bg Color',
            name: 'cartViewOrderBtnBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for view order button in the bottom of the cart page'
        },
        cartViewOrderBtnBorderColor: {
            label: 'View Order Btn Border Color',
            name: 'cartViewOrderBtnBorderColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Border color for view order button in the bottom of the cart page'
        },
        cartViewOrderBtnFontColor: {
            label: 'View Order Btn Font Color',
            name: 'cartViewOrderBtnFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for view order button in the bottom of the cart page'
        },
        cartBackBtnBgColor: {
            label: 'Back Btn Bg Color',
            name: 'cartBackBtnBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for back button in the bottom of the cart page'
        },
        cartBackBtnBorderColor: {
            label: 'Back Btn Border Color',
            name: 'cartBackBtnBorderColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Border color for back button in the bottom of the cart page'
        },
        cartBackBtnFontColor: {
            label: 'BackBtn Font Color',
            name: 'cartBackBtnFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for back button in the bottom of the cart page'
        },
        cartCheckoutBtnBgColor: {
            label: 'Checkout Btn Bg Color',
            name: 'cartCheckoutBtnBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for checkout button in the bottom of the cart page'
        },
        cartCheckoutBtnBorderColor: {
            label: 'Checkout Btn Border Color',
            name: 'cartCheckoutBtnBorderColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Border color for checkout button in the bottom of the cart page'
        },
        cartCheckoutBtnFontColor: {
            label: 'Checkout Btn Font Color',
            name: 'cartCheckoutBtnFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for checkout button in the bottom of the cart page'
        }
    },
    [SectionNames.CheckoutTab]: {
        checkoutBgColor: {
            label: 'Bg Color',
            name: 'checkoutBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for checkout page'
        },
        checkoutCardsBgColor: {
            label: 'Cards Bg Color',
            name: 'checkoutCardsBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for card sections in the checkout page'
        },
        checkoutCardsSecondaryBgColor: {
            label: 'Cards Secondary Bg Color',
            name: 'checkoutCardsSecondaryBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for address section in the shipping card in the checkout page'
        },
        checkoutCardsFontColor: {
            label: 'Cards Font Color',
            name: 'checkoutCardsFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for card sections in the checkout page'
        },
        checkoutFontColor: {
            label: 'Font Color',
            name: 'checkoutFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for Tips & sub text in the checkout page'
        },
        checkoutBillingPriceFontSize: {
            label: 'Billing Price Font Size (Default 16px)',
            name: 'checkoutBillingPriceFontSize',
            defaultValue: null,
            type: FieldTypes.fontsize
        },
        checkoutBillingTotalPriceFontSize: {
            label: 'Billing Total Price Font Size (Default 19px)',
            name: 'checkoutBillingTotalPriceFontSize',
            defaultValue: null,
            type: FieldTypes.fontsize
        },
        checkoutPaymentBtnBgColor: {
            label: 'Payment Btn Bg Color',
            name: 'checkoutPaymentBtnBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for pay button in the bottom of the checkout page'
        },
        checkoutPaymentBtnFontColor: {
            label: 'Payment Btn Font Color',
            name: 'checkoutPaymentBtnFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for pay button in the bottom of the checkout page'
        },
        checkoutTipsBgColor: {
            label: 'Tips Bg Color',
            name: 'checkoutTipsBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for tips list in the checkout page'
        },
        checkoutTipsSelectedBgColor: {
            label: 'Tips Selected Bg Color',
            name: 'checkoutTipsSelectedBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for selected tip in the checkout page'
        },
        checkoutTipsFontColor: {
            label: 'Tips Font Color',
            name: 'checkoutTipsFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for tips list in the checkout page'
        },
        checkoutTipsSelectedFontColor: {
            label: 'Tips Selected Font Color',
            name: 'checkoutTipsSelectedFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for selected tip in the checkout page'
        },
        checkoutTipsPencilIconColor: {
            label: 'Tips Pencil Icon Color',
            name: 'checkoutTipsPencilIconColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Color for tip edit icon in the checkout page'
        },
        checkoutTipsPopupBgColor: {
            label: 'Tips Popup Bg Color',
            name: 'checkoutTipsPopupBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for tips popup in the checkout page'
        },
        checkoutTipsPopupTitleColor: {
            label: 'Tips Popup Title Color',
            name: 'checkoutTipsPopupTitleColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for title text in the tips popup in the checkout page'
        },
        checkoutTipsPopupFontColor: {
            label: 'Tips Popup Font Color',
            name: 'checkoutTipsPopupFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for text in the bottom of the tips popup in the checkout page'
        },
        checkoutTipsPopupLabelColor: {
            label: 'Tips Popup Label Color',
            name: 'checkoutTipsPopupLabelColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for input label in the tips popup in the checkout page'
        },
        checkoutTipsPopupAddBtnBgColor: {
            label: 'Tips Popup Add Btn Bg Color',
            name: 'checkoutTipsPopupAddBtnBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for add button in the tips popup in the checkout page'
        },
        checkoutTipsPopupAddBtnFontColor: {
            label: 'Tips Popup Add Btn Font Color',
            name: 'checkoutTipsPopupAddBtnFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for add button in the tips popup in the checkout page'
        },
        checkoutTableNoBgColor: {
            label: 'Table No Bg Color',
            name: 'checkoutTableNoBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for table number in the top card section of the checkout page'
        },
        checkoutTableNoFontColor: {
            label: 'Table No Font Color',
            name: 'checkoutTableNoFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for table number in the top card section of the checkout page'
        }
    },
    [SectionNames.OrderSuccessTab]: {
        orderSuccessBgColor: {
            label: 'Bg Color',
            name: 'orderSuccessBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for order success page'
        },
        orderSuccessHeaderBgColor: {
            label: 'Header Bg Color',
            name: 'orderSuccessHeaderBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for header in the order success page'
        },
        orderSuccessHeaderFontColor: {
            label: 'Header Font Color',
            name: 'orderSuccessHeaderFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for header title in the order success page'
        },
        orderSuccessCardBgColor: {
            label: 'Card Bg Color',
            name: 'orderSuccessCardBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for card sections in the order success page'
        },
        orderSuccessCardFontColor: {
            label: 'Card Font Color',
            name: 'orderSuccessCardFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for card sections in the order success page'
        },
        orderSuccessMiniInvoiceWidgetPrimaryBgColor: {
            label: 'Mini Invoice Widget Primary Bg Color',
            name: 'orderSuccessMiniInvoiceWidgetPrimaryBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for mini invoice widget card in the order success page'
        },
        orderSuccessMiniInvoiceWidgetPrimaryFontColor: {
            label: 'Mini Invoice Widget Primary Font Color',
            name: 'orderSuccessMiniInvoiceWidgetPrimaryFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for mini invoice widget card in the order success page'
        },
        orderSuccessMiniInvoiceWidgetSecondaryBgColor: {
            label: 'Mini Invoice Widget Secondary Bg Color',
            name: 'orderSuccessMiniInvoiceWidgetSecondaryBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for bottom section of the mini invoice widget card in the order success page'
        },
        orderSuccessMiniInvoiceWidgetSecondaryFontColor: {
            label: 'Mini Invoice Widget Secondary Font Color',
            name: 'orderSuccessMiniInvoiceWidgetSecondaryFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for bottom section of the mini invoice widget card in the order success page'
        },
        orderSuccessBackBtnBgColor: {
            label: 'Back Btn Bg Color',
            name: 'orderSuccessBackBtnBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for back button in the bottom of the order success page'
        },
        orderSuccessBackBtnFontColor: {
            label: 'Back Btn Font Color',
            name: 'orderSuccessBackBtnFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for back button in the bottom of the order success page'
        }
    },
    [SectionNames.OrderHistoryTab]: {
        orderHistoryHeaderBgColor: {
            label: 'Header Bg Color',
            name: 'orderHistoryHeaderBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for header in the order history page'
        },
        orderHistoryHeaderFontColor: {
            label: 'Header Font Color',
            name: 'orderHistoryHeaderFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for header title in the order history page'
        },
        orderHistoryBgColor: {
            label: 'Bg Color',
            name: 'orderHistoryBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for order history page'
        },
        orderHistorySearchInputBgColor: {
            label: 'Search Input Bg Color',
            name: 'orderHistorySearchInputBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for search input in the order history page'
        },
        orderHistorySearchInputLabelFontColor: {
            label: 'Search Input Label Font Color',
            name: 'orderHistorySearchInputLabelFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for search input label in the order history page'
        },
        orderHistorySearchInputFontColor: {
            label: 'Search Input Font Color',
            name: 'orderHistorySearchInputFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for search input in the order history page'
        },
        orderHistoryCardBgColor: {
            label: 'Card Bg Color',
            name: 'orderHistoryCardBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for card sections in the order history page'
        },
        orderHistoryCardFontColor: {
            label: 'Card Font Color',
            name: 'orderHistoryCardFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for card sections in the order history page'
        },
        orderHistoryCardTableNoBgColor: {
            label: 'Card Table No. Bg Color',
            name: 'orderHistoryCardTableNoBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for table number in the card in the order history page'
        },
        orderHistoryCardTableNoFontColor: {
            label: 'Card Table No. Font Color',
            name: 'orderHistoryCardTableNoFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for table number in the card in the order history page'
        }
    },
    [SectionNames.OrderDetailsTab]: {
        orderDetailHeaderBgColor: {
            label: 'Header Bg Color',
            name: 'orderDetailHeaderBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for header in the order detail page'
        },
        orderDetailHeaderFontColor: {
            label: 'Header Font Color',
            name: 'orderDetailHeaderFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for header title in the order detail'
        },
        orderDetailBgColor: {
            label: 'Bg Color',
            name: 'orderDetailBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for order detail page'
        },
        orderDetailCardBgColor: {
            label: 'Card Bg Color',
            name: 'orderDetailCardBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for card sections in the order detail page'
        },
        orderDetailCardFontColor: {
            label: 'Card Font Color',
            name: 'orderDetailCardFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for card sections in the order detail page'
        },
        orderDetailCardBillWidgetBgColor: {
            label: 'Card Bill Widget Bg Color',
            name: 'orderDetailCardBillWidgetBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for bill widget card section in the order detail page'
        },
        orderDetailCardBillWidgetFontColor: {
            label: 'Card Bill Widget Font Color',
            name: 'orderDetailCardBillWidgetFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for bill widget card section in the order detail page'
        }
    },
    [SectionNames.AddAddressTab]: {
        addAddressHeaderBgColor: {
            label: 'Header Bg Color',
            name: 'addAddressHeaderBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for header in the add address page'
        },
        addAddressHeaderFontColor: {
            label: 'Header Font Color',
            name: 'addAddressHeaderFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for header title in the add address page'
        },
        addAddressBackBtnBgColor: {
            label: 'Back Btn Bg Color',
            name: 'addAddressBackBtnBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for header back button in the add address page'
        },
        addAddressBackBtnIconColor: {
            label: 'Back Btn Icon Color',
            name: 'addAddressBackBtnIconColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Color for header back icon in the add address page'
        },
        addAddressBgColor: {
            label: 'Bg Color',
            name: 'addAddressBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for add address page'
        },
        addAddressCardBgColor: {
            label: 'Card Bg Color',
            name: 'addAddressCardBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for card sections in the add address page'
        },
        addAddressCardTitleFontColor: {
            label: 'Card Title Font Color',
            name: 'addAddressCardTitleFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for title text in the card in the add address page'
        },
        addAddressCardInputLabelFontColor: {
            label: 'Card Input Label Font Color',
            name: 'addAddressCardInputLabelFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for label text in the card in the add address page'
        },
        addAddressCardInputBgColor: {
            label: 'Card Input Bg Color',
            name: 'addAddressCardInputBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for inputs in the card in the add address page'
        },
        addAddressCardInputFontColor: {
            label: 'Card Input Font Color',
            name: 'addAddressCardInputFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for inputs in the card in the add address page'
        },
        addAddressCardInputIconColor: {
            label: 'Card Input Icon Color',
            name: 'addAddressCardInputIconColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Color for icon in the card inputs in the add address page'
        },
        addAddressAddBtnBgColor: {
            label: 'Add Icon Bg Color',
            name: 'addAddressAddBtnBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for add icon in the address card section in the add address page'
        },
        addAddressAddBtnFontColor: {
            label: 'Add Icon & Font Color',
            name: 'addAddressAddBtnFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for add icon & text in the address card section in the add address page'
        },
        addAddressCheckboxBtnIconColor: {
            label: 'Checkbox Btn Icon Color',
            name: 'addAddressCheckboxBtnIconColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Color for checkbox btn in the add address page'
        },
        addAddressRadioBtnIconColor: {
            label: 'Radio Btn Icon Color',
            name: 'addAddressRadioBtnIconColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Color for radio btn in the add address page'
        },
        addAddressSaveBtnBgColor: {
            label: 'Save Btn Bg Color',
            name: 'addAddressSaveBtnBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for save button in the add address page'
        },
        addAddressSaveBtnFontColor: {
            label: 'Save Btn Font Color',
            name: 'addAddressSaveBtnFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for save button in the add address page'
        },
        addAddressCancelBtnBgColor: {
            label: 'Cancel Btn Bg Color',
            name: 'addAddressCancelBtnBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for cancel button in the add address page'
        },
        addAddressCancelBtnFontColor: {
            label: 'Cancel Btn Font Color',
            name: 'addAddressCancelBtnFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for cancel button in the add address page'
        }
    },
    [SectionNames.AddressListTab]: {
        addressListHeaderBgColor: {
            label: 'Header Bg Color',
            name: 'addressListHeaderBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for header in the address list page'
        },
        addressListHeaderFontColor: {
            label: 'Header Font Color',
            name: 'addressListHeaderFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for header title in the address list page'
        },
        addressListBackBtnBgColor: {
            label: 'Back Btn Bg Color',
            name: 'addressListBackBtnBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for header back button in the address list page'
        },
        addressListBackBtnIconColor: {
            label: 'Back Btn Icon Color',
            name: 'addressListBackBtnIconColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Color for header back icon in the address list page'
        },
        addressListBgColor: {
            label: 'Bg Color',
            name: 'addressListBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for address list page'
        },
        addressListFontColor: {
            label: 'Font Color',
            name: 'addressListFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: "Font color for 'choose an address' text in the address list page"
        },
        addressListCardBgColor: {
            label: 'Card Bg Color',
            name: 'addressListCardBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for card sections in the address list page'
        },
        addressListCardPrimaryFontColor: {
            label: 'Card Primary Font Color',
            name: 'addressListCardPrimaryFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for address serial no. text in the card in the address list page'
        },
        addressListCardSecondaryFontColor: {
            label: 'Card Secondary Font Color',
            name: 'addressListCardSecondaryFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for address text in the card in the address list page'
        },
        addressListCardEditIconColor: {
            label: 'Card Edit Icon Color',
            name: 'addressListCardEditIconColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Color for edit icon in the address list page'
        },
        addressListAddBtnBgColor: {
            label: 'Add Icon Bg Color',
            name: 'addressListAddBtnBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for add new address icon in the add address page'
        },
        addressListAddBtnFontColor: {
            label: 'Add Icon & Font Color',
            name: 'addressListAddBtnFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Color for add new address icon & text in the add address page'
        },
        addressListRadioBtnIconColor: {
            label: 'Radio Btn Icon Color',
            name: 'addressListRadioBtnIconColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Color for radio btn in the address list page'
        },
        addressListSaveBtnBgColor: {
            label: 'Save Btn Bg Color',
            name: 'addressListSaveBtnBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for save button in the address list page'
        },
        addressListSaveBtnFontColor: {
            label: 'Save Btn Font Color',
            name: 'addressListSaveBtnFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for save button in the address list page'
        },
        addressListCancelBtnBgColor: {
            label: 'Cancel Btn Bg Color',
            name: 'addressListCancelBtnBgColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Background color for cancel button in the address list page'
        },
        addressListCancelBtnFontColor: {
            label: 'Cancel Btn Font Color',
            name: 'addressListCancelBtnFontColor',
            defaultValue: null,
            type: FieldTypes.color,
            info: 'Font color for cancel button in the address list page'
        }
    },
    [SectionNames.PaymentSettingsTab]: {
        stripeDestinationAccountId: {
            label: "Stripe Destination Account ID",
            name: "stripeDestinationAccountId",
            defaultValue: "",
            type: FieldTypes.stringInput,
            info: "Account ID for Stripe payment gateway",
        },
        ryftDestinationAccountId: {
            label: "Ryft Destination Account ID",
            name: "ryftDestinationAccountId",
            defaultValue: "",
            type: FieldTypes.stringInput,
            info: "Account ID for Ryft payment gateway",
        },
        onlineOrderDefaultGateway: {
            label: "Online Order Default Gateway",
            name: "onlineOrderDefaultGateway",
            defaultValue: "stripe",
            type: FieldTypes.select,
            info: "Default payment gateway for online orders",
            optionsList: PAYMENT_GATEWAYS
        },
        onlineOrderApplicationFeePercent: {
            label: "Online Order Application Fee (%)",
            name: "onlineOrderApplicationFeePercent",
            defaultValue: 0,
            type: FieldTypes.stringInput,
            info: "Application fee percentage for online orders",
        },
        tableOrderDefaultGateway: {
            label: "Table Order Default Gateway",
            name: "tableOrderDefaultGateway",
            defaultValue: "direct",
            type: FieldTypes.select,
            info: "Default payment gateway for table orders",
            optionsList: TABLE_ORDER_GATEWAYS
        },
        tableOrderApplicationFeePercent: {
            label: "Table Order Application Fee (%)",
            name: "tableOrderApplicationFeePercent",
            defaultValue: 0,
            type: FieldTypes.stringInput,
            info: "Application fee percentage for table orders",
        },
        tableBookingDepositDefaultGateway: {
            label: "Table Booking Deposit Default Gateway",
            name: "tableBookingDepositDefaultGateway",
            defaultValue: "stripe",
            type: FieldTypes.select,
            info: "Default payment gateway for table booking deposits",
            optionsList: PAYMENT_GATEWAYS
        },
        tableBookingDepositApplicationFeePercent: {
            label: "Table Booking Deposit Application Fee (%)",
            name: "tableBookingDepositApplicationFeePercent",
            defaultValue: 0,
            type: FieldTypes.stringInput,
            info: "Application fee percentage for table booking deposits",
        },
        giftCardDefaultGateway: {
            label: "Gift Card Default Gateway",
            name: "giftCardDefaultGateway",
            defaultValue: "stripe",
            type: FieldTypes.select,
            info: "Default payment gateway for gift cards",
            optionsList: PAYMENT_GATEWAYS
        },
        giftCardApplicationFeePercent: {
            label: "Gift Card Application Fee (%)",
            name: "giftCardApplicationFeePercent",
            defaultValue: 0,
            type: FieldTypes.stringInput,
            info: "Application fee percentage for gift cards",
        },
    },
    [SectionNames.MultiLanguageTab]: {
        isEnabled: {
            label: "Enable Multi-Language Support",
            name: "isEnabled",
            defaultValue: false,
            type: FieldTypes.switch,
            info: "Toggle to enable multi-language support for the restaurant",
        },
        languages: {
            label: "Supported Languages",
            name: "languages",
            defaultValue: [],
            type: FieldTypes.select,
            info: "Select the languages you want to support",
            isMultiSelect: true,
        },
    }
}

export {
    CategoriesFields,
    SocialMediaFields,
    SectionNames,
    FieldTypes,
    MetaData,
    APP_TYPE_LIST,
    PAYMENT_GATEWAYS,
    TABLE_ORDER_GATEWAYS
}